"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statisticSourceTypeOptions = exports.statisticErrorMessage = exports.statisticColumns = exports.sourceTypeLabel = exports.resetIntervalOptions = exports.resetIntervalLabel = exports.operationLabel = exports.INITIAL_VISIBLE_COLUMNS = exports.describeNextReset = exports.aggregationMethodOptions = void 0;
var utils_1 = require("@doshexchnage/utils");
var statisticColumns = [
    { name: "Name", uid: "name", sortable: true },
    { name: "Aggregation Method", uid: "aggregation_method", sortable: true },
    { name: "Reset Interval", uid: "reset_interval", sortable: true },
    { name: "Version", uid: "version", sortable: true },
    { name: "Next Reset", uid: "next_reset_at" },
    { name: "Created", uid: "created_at", sortable: true },
    { name: "Actions", uid: "actions" },
];
exports.statisticColumns = statisticColumns;
var INITIAL_VISIBLE_COLUMNS = ["name", "aggregation_method", "reset_interval", "version", "next_reset_at", "created_at", "actions"];
exports.INITIAL_VISIBLE_COLUMNS = INITIAL_VISIBLE_COLUMNS;
var aggregationMethodOptions = [
    { key: "Sum", label: "Sum" },
    { key: "Max", label: "Max" },
    { key: "Min", label: "Min" },
    { key: "Last", label: "Last" },
];
exports.aggregationMethodOptions = aggregationMethodOptions;
var resetIntervalOptions = [
    { key: "Never", label: "Never" },
    { key: "Manual", label: "Manual" },
    { key: "Hour", label: "Hourly" },
    { key: "Day", label: "Daily" },
    { key: "Week", label: "Weekly" },
    { key: "Month", label: "Monthly" },
    { key: "Year", label: "Yearly" },
];
exports.resetIntervalOptions = resetIntervalOptions;
var statisticSourceTypeOptions = [
    { key: "order", label: "Order" },
    { key: "order_reversal", label: "Order reversal" },
    { key: "gift", label: "Gift" },
    { key: "gift_reversal", label: "Gift reversal" },
    { key: "subscription", label: "Subscription" },
    { key: "objective", label: "Challenge objective" },
    { key: "reward", label: "Reward" },
    { key: "reward_track", label: "Reward track" },
    { key: "grant", label: "Admin grant" },
    { key: "registration", label: "Registration" },
    { key: "annual_reset", label: "Annual reset" },
    { key: "backfill", label: "Backfill" },
    { key: "leaderboard_reset", label: "Leaderboard reset" },
];
exports.statisticSourceTypeOptions = statisticSourceTypeOptions;
var statisticOperationOptions = [
    { key: "increment", label: "Increment" },
    { key: "set", label: "Set" },
    { key: "set_max", label: "Set if higher" },
];
var resetIntervalLabel = function (interval) { var _a, _b; return (_b = (_a = resetIntervalOptions.find(function (option) { return option.key === interval; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : interval; };
exports.resetIntervalLabel = resetIntervalLabel;
var sourceTypeLabel = function (sourceType) { var _a, _b; return (_b = (_a = statisticSourceTypeOptions.find(function (option) { return option.key === sourceType; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : sourceType; };
exports.sourceTypeLabel = sourceTypeLabel;
var operationLabel = function (operation) { var _a, _b; return (_b = (_a = statisticOperationOptions.find(function (option) { return option.key === operation; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : operation; };
exports.operationLabel = operationLabel;
var describeNextReset = function (resetInterval, nextResetAt) {
    if (resetInterval === "Never")
        return "Never resets";
    if (resetInterval === "Manual")
        return "Resets manually";
    if (!nextResetAt)
        return "Not scheduled";
    return "Resets ".concat((0, utils_1.formatDateTime)(new Date(nextResetAt)));
};
exports.describeNextReset = describeNextReset;
// a 400 from the service carries its message in data, while a 200 with success false surfaces it as error
var statisticErrorMessage = function (error) {
    var _a;
    var failure = error;
    return ((_a = failure === null || failure === void 0 ? void 0 : failure.data) === null || _a === void 0 ? void 0 : _a.message) || (failure === null || failure === void 0 ? void 0 : failure.error) || "The request was unsuccessful.";
};
exports.statisticErrorMessage = statisticErrorMessage;
